export default function scrollIntoView(id) {
    const targetSection = document.getElementById(id);
    targetSection.scrollIntoView({ behavior: 'smooth' });
}